const blop = require("!/Users/batistebieler/project/blop-language/src/runtime.js");
let state;
let create = require('./lib/state.blop').create;

state = ({
  todoList: [
    'Buy some milk',
    'Take out the trash',
    'Recycle'
  ],
  dogPage: ({ score: 0, attempt: 0, success: 0 }),
  petStore: ({ pets: [], pageIndex: 0 }),
  page: 'index',
  memes: [],
  loading: false
});


function createState(initialState) {
  return create(initialState || state)
};

module.exports = { create, state, createState };
